import React from "react";

type PageStateProps = {
  loading: boolean;
  error?: string | null;
  children: React.ReactNode;
};

export const PageState: React.FC<PageStateProps> = ({
  loading,
  error,
  children,
}) => {
  if (loading) {
    return <div className="alert alert-info">Carregando...</div>;
  }

  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      {children}
    </>
  );
};
